<template>
    <div :class="'mb-3 db-doughnut ' + computed_col" v-show="runSleep">
        <div :class="computed_col != '' ? 'card' : ''">
            <div v-if="title" class="card-header d-flex justify-content-between align-items-center bg-white">
                <span class="title">{{title}}</span>
                <spinner-clip-loader class="mt-2" v-show="loading"></spinner-clip-loader>
            </div>
            <div :class="computed_col != '' ? 'card-body p-3' : ''">
                <div>
                    <div :class="computed_height">
                        <v-doughnut-chart :chart-data="datacollection" :options="options"></v-doughnut-chart>
                    </div>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>  
</template>

<script>
import DoughnutChart from '../DoughnutChart';
import spinnerClipLoader from 'vue-spinner/src/ClipLoader.vue'
import Axios from 'axios';

export default {
    components: {
        DoughnutChart,
        spinnerClipLoader,
    },
    props: [
        'col',
        'color',
        'display',
        'title',
        'labels',
        'values',
        'dataset',
        'trigger',
        'route',
        'sleep',
    ],
    data() { return {
        datacollection: null,
        options: null,
        dataValues: [],
        runSleep: false,
        loading: false,
    }},
    computed: {
        computed_col() {
            if(this.col == undefined || this.col == 'true' || this.col == true) {
                return 'col-xs-12 col-md-4 col-lg-4';
            } else if(this.col == 'auto') {
                return 'col';
            } else if(this.col == 'false' || this.col == false) {
                return '';
            } else {
                return this.col;
            }
        },
        computed_color() {
            switch (this.color) {
                case undefined:
                    return '#0275d8';
                case 'primary':
                    return '#0275d8';
                case 'secondary':
                    return '#292b2c';
                case 'success':
                    return '#5cb85c';
                case 'info':
                    return '#5bc0de';
                case 'warning':
                    return '#f0ad4e';
                case 'danger':
                    return '#d9534f';
                default: return '#0275d8';
            }
        },
        computed_display() {
            if(this.display == 'auto') {
                return true;
            }
            else if(this.display == 'fixed') {
                return false;
            }
            else {
                return false;
            }
        },
        computed_height() {
            if(this.display == undefined || this.display == 'fixed') {
                return '';
            }
            else if (this.display == 'sm') {
                return 'h-sm';
            }
        },
    },
    mounted() {
        const vm = this;
        const disparador = $('#'+this.trigger);

        if(this.sleep == 'true' || this.sleep == true) {
            this.runSleep = false;
        } else {
            this.runSleep = true;
            vm.loading = true;
            vm.preGet(disparador);
        }

        disparador.on('submit', function() {
            vm.loading = true;
            vm.preGet(disparador);
        });

        this.fillData();
    },
    methods: {
        preGet(disparador) {
            const params = {};
            const data = disparador.serializeArray();
            data.forEach(item => {
                params[item.name] = item.value;
            });
            this.get(params);
        },
        get(data) {
            Axios.get(this.route, {params: data}).then(res => {
                this.dataValues = res.data;
                this.fillData();
                this.runSleep = true;
                this.loading = false;
            }).catch(e => {
                console.log(e);
                this.loading = false;
            });
        },
        fillData() {
            /* if(this.dataset) {
                this.datacollection = {
                    labels: this.labels,
                    datasets: this.dataset
                }
            } else { */
                this.datacollection = {
                    labels: this.labels,
                    datasets: [
                        {
                            data: this.dataValues ? this.dataValues : this.values,
                            backgroundColor: this.color,
                        }
                    ],
                }
            //}

            this.options = {
                legend: {
                    display: false,
                },
                circumference: 2 * Math.PI,
            }       
        },
    },
}
</script>